import { EbCompagnie } from "../classes/compagnie";
import { EbEtablissement } from "../classes/etablissement";
import { role } from "../classes/role";
import { Input } from "../utils/Input";
import { EbRelation } from "./relation";
import { EbContactRequest } from "./contactRequest";
import { ExUserModule } from "./accessRight";
import { EbCategorie } from "./categorie";
import { ParamsMail } from "./paramsMail";

export class EbUser {
	ebUserNum: number;
	nom: string;
	prenom: string;
	adresse: string;
	email: string;

	telephone: string;
	password: string;
	confimPassword: string;
	admin: boolean;
	//xEcRoleUser: role;
	inputs: Array<Input>;
	ebEtablissement: EbEtablissement;
	ebCompagnie: EbCompagnie;
	resetToken: string;
	contacts: Array<EbUser>;
	sendingRequest: Array<EbContactRequest>;
	receivingResquest: Array<EbContactRequest>;
	service: number;
	status: number;
	listAccessRights: Array<ExUserModule>;
	superAdmin: boolean;
	ebRelation: EbRelation;
	etat: number;
	role: number;
	serviceTransporteur: boolean;
	serviceBroker: boolean;
	listCategories: Array<EbCategorie>;
	language: string;
	roleLibelle: string;
	roleChargeur: Boolean;
	rolePrestataire: Boolean;
	groupeName: string;
	uniqueAdminOfEtablissement: Boolean;
	isCt?: boolean;

	realUserNum: number;
	realUserNom: string;
	realUserPrenom: string;
	realUserEmail: string;
	realUserPassword: string;
	realUserEtabNum: number;
	realUserEtabNom: string;
	realUserCompNum: number;
	realUserCompNom: string;

	listParamsMail: Array<ParamsMail>;
	//pour récupérer le scénation de la compagnie du user connecté
	realUserCompScenario: number;
	recevoirNotifConfirmation: boolean;
	recevoirNotifCreation: boolean;

	constructor() {
		this.ebUserNum = null;
		this.nom = null;
		this.prenom = null;
		this.adresse = null;
		this.email = null;
		this.telephone = null;
		this.admin = null;
		this.password = null;
		this.confimPassword = null;
		this.inputs = new Array<Input>();
		this.ebEtablissement = new EbEtablissement();
		//this.ebCompagnie = new EbCompagnie();
		//this.xEcRoleUser = new role();
		this.resetToken = null;
		this.contacts = new Array<EbUser>();
		this.sendingRequest = new Array<EbContactRequest>();
		this.receivingResquest = new Array<EbContactRequest>();
		this.service = null;
		this.status = null;
		this.listAccessRights = new Array<ExUserModule>();
		this.superAdmin = null;
		this.ebRelation = null;
		this.etat = null;
		this.role = null;
		this.serviceTransporteur = false;
		this.serviceBroker = false;
		this.language = "en";
		this.roleLibelle = null;
		this.roleChargeur = false;
		this.rolePrestataire = false;
		this.groupeName = null;
		this.uniqueAdminOfEtablissement = false;

		this.realUserNum = null;
		this.realUserNom = null;
		this.realUserPrenom = null;
		this.realUserEmail = null;
		this.realUserPassword = null;
		this.realUserEtabNum = null;
		this.realUserEtabNom = null;
		this.realUserCompNum = null;
		this.realUserCompNom = null;

		this.listParamsMail = new Array<ParamsMail>();
		this.realUserCompScenario = null;
		this.recevoirNotifConfirmation = false;
		this.recevoirNotifCreation = false;
	}

	constructorCopy(user: EbUser) {
		this.ebUserNum = user.ebUserNum;
		this.nom = user.nom;
		this.prenom = user.prenom;
		this.adresse = user.adresse;
		this.email = user.email;
		this.telephone = user.telephone;
		this.admin = user.admin;
		this.password = user.password;
		this.confimPassword = user.confimPassword;
		this.inputs = user.inputs;
		this.ebEtablissement = user.ebEtablissement;
		//this.xEcRoleUser = user.xEcRoleUser;
		this.resetToken = user.resetToken;
		this.listAccessRightsCopy(user.listAccessRights);
		this.status = user.status;
		this.service = user.service;
		this.admin = user.admin;
		this.superAdmin = user.superAdmin;
		this.role = user.role;
		this.serviceTransporteur = user.serviceTransporteur;
		this.serviceBroker = user.serviceBroker;
		this.roleLibelle = user.roleLibelle;
		this.roleChargeur = user.roleChargeur;
		this.rolePrestataire = user.rolePrestataire;
		this.groupeName = user.groupeName;

		this.realUserNum = user.realUserNum;
		this.realUserNom = user.realUserNom;
		this.realUserPrenom = user.realUserPrenom;
		this.realUserEmail = user.realUserEmail;
		this.realUserPassword = user.realUserPassword;
		this.realUserEtabNum = user.realUserEtabNum;
		this.realUserEtabNom = user.realUserEtabNom;
		this.realUserCompNum = user.realUserCompNum;
		this.realUserCompNom = user.realUserCompNom;
		this.realUserCompScenario = user.realUserCompScenario;
		this.recevoirNotifConfirmation = user.recevoirNotifConfirmation;
		this.recevoirNotifCreation = user.recevoirNotifCreation;
	}

	constructorCopyLite(user: EbUser) {
		this.ebUserNum = user.ebUserNum;
		this.nom = user.nom;
		this.email = user.email;
		this.role = user.role;
		this.service = user.service;
		this.status = user.status;
		this.admin = user.admin;
		this.superAdmin = user.superAdmin;
		if (user.ebEtablissement != null) {
			this.ebEtablissement = new EbEtablissement();
			this.ebEtablissement.ebEtablissementNum = user.ebEtablissement.ebEtablissementNum;
		}

		if (user.ebCompagnie != null) {
			this.ebCompagnie = new EbCompagnie();
			this.ebCompagnie.ebCompagnieNum = user.ebCompagnie.ebCompagnieNum;
		}
	}

	listAccessRightsCopy(listAccessRights: Array<ExUserModule>) {
		let _accessRight;
		if (listAccessRights !== undefined && listAccessRights !== null && listAccessRights.length !== 0) {
			for (let right of listAccessRights) {
				_accessRight = new ExUserModule();
				_accessRight.constructorCopy(right);
				this.listAccessRights.push(_accessRight);
			}
		}
		else {
			this.listAccessRights = new Array<ExUserModule>();
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/classes/user.ts